import React, { useState } from "react";
import { useNavigate } from "react-router";
import imgs from "../../../../../../assets/images/imgs";
import { useSelector } from "react-redux";
import './StudentSuggesionTeacherCard.css';
import { Tooltip } from "react-tooltip";

const StudentSuggesionTeacherCard = ({ teacher, onNavigateAway }) => {
  const navigate = useNavigate();
  const globalState = useSelector((state) => state.globalState);
  const [imgLoaded, setImgLoaded] = useState(false);

  const handleBookMeeting = () => {
    // Navigate to teacher profile with booking modal open
    navigate(`/teacher/${teacher.teacher_id}`, {
      state: { openBookingModal: true, teacher }
    });
    if (typeof onNavigateAway === "function") onNavigateAway();
  };

  const handleViewProfile = () => {
    navigate(`/teacher/${teacher.teacher_id}`, {
      state: { teacher }
    });
    if (typeof onNavigateAway === "function") onNavigateAway();
  };

  const getOfferingLabel = () => {
    if (!teacher.offerings || teacher.offerings.length === 0) return "No offerings";
    const offering = teacher.offerings[0];
    return `${offering.duration_minutes}min - ${offering.currency}${offering.price}`;
  };

  return (
    <div
      className="studentDashboar-Suggested-Courses-folder teacher-card"
      onClick={handleViewProfile}
      style={{ cursor: "pointer" }}
    >
      {/* Teacher Avatar Background */}
      <div className="teacher-card-avatar-section">
        <img
          src={teacher?.ai_avatar || imgs.png.tearcher_profile_image}
          alt={teacher?.name}
          className="teacher-card-avatar"
          onLoad={() => setImgLoaded(true)}
          onError={() => setImgLoaded(true)}
        />
      {globalState?.enabled_modules?.includes("marketplace") && (
        <div>
        {teacher?.is_trial && (
          <span className="free-trial-badge">Free Trial</span>
        )}
        </div>
      )}

        <div className="teacher-card-header">
            <h3 className="teacher-card-name">{teacher?.name}</h3>
           {/* Rating */}
      {globalState?.enabled_modules?.includes("marketplace") && (
        <div className="teacher-card-rating">
          <div className="rating-stars">
            <i className="fa-solid fa-star"></i>
            <span className="rating-value">{teacher?.average_rating || "0"}</span>
            <span className="rating-count">({teacher?.rating_count || 0})</span>
          </div>
        </div>
      )}
        </div>
        <p className="teacher-card-introduction">{teacher?.introduction}</p>
      </div>

      {/* Teacher Info */}
      <div className="teacher-card-content">

        {/* Action Buttons */}
        <div className="teacher-card-actions">
          <button
            className="teacher-btn teacher-btn-secondary"
            onClick={handleViewProfile}
          >
            View Profile
          </button>
        </div>
      </div>
    </div>
  );
};

export default StudentSuggesionTeacherCard;
